import i18n from "../common/languageHandling/i18n";

const alerts = [
  { id: 1, description: "M-Bus Application busy" },
  { id: 2, description: "M-Bus Application error" },
  { id: 3, description: "M-Bus Abnormal condition alarm" },
  { id: 4, description: "M-Bus Power low" },
  { id: 5, description: "M-Bus Permanent error" },
  { id: 6, description: "M-Bus Temporary error" },
  { id: 7, description: i18n.t("EGD Error") },
  { id: 8, description: i18n.t("EGD measurement range error") },
  { id: 9, description: i18n.t("EGD Uknown error") },
  { id: 10, description: i18n.t("No reception. Reason unit") },
  { id: 11, description: i18n.t("No reception. Reason collection unit") },
  { id: 12, description: i18n.t("No reception. Reason uncertain") },
  { id: 13, description: i18n.t("Fire alarm") },
  { id: 14, description: i18n.t("Leakage") },
  { id: 15, description: i18n.t("Sabotage") },
  { id: 16, description: i18n.t("Internal sensor communication error") },
  { id: 17, description: i18n.t("Encryption key is missing") },
  { id: 18, description: i18n.t("Failed decryption") },
  { id: 19, description: i18n.t("Alarm") },
];

export enum EventType {
  MBusApplicationBusy = 1,
  MBusApplicationError = 2,
  MBusAbnormalConditionAlarm = 3,
  MBusPowerLow = 4,
  MBusPermanentError = 5,
  MBusTemporaryError = 6,
  EGDError = 7,
  EGDMeasurementRangeError = 8,
  EGDUnknownError = 9,
  NoReceptionReasonUnit = 10,
  NoReceptionReasonCollectionUnit = 11,
  NoReceptionReasonUncertain = 12,
  Leakage = 14,
  Sabotage = 15,
  InternalSensorCommunicationError = 16,
  EncryptionKeyIsMissing = 17,
  FailedDecryption = 18,
  Alarm = 19,
}

export const getDeviceAlertDescription = (code: number): string => {
  return (
    alerts.find((a) => a.id === code)?.description ??
    i18n.t("Missing description")
  );
};
